import { mapState, mapGetters } from 'vuex';
import { getStateOption } from '@/utils/deviceUtils/state';

import ctt from '@/utils/const';
import {
  setDeviceCoordinate,
  toHisWarn,
  modifyParam,
  analysisModel,
  testingRecord,
  toExpert,
  toHisData,
  mulMonitor,
  bgroundState,
  toHisData2,
  toFaultRecord,
  musicboxSetting,
  musicboxSysStatus,
  makeBC500SysStatus,
  makeBC500Setting,
  // popRG05Setting,
  toSampleRecord,
  // openDocument,
  setDeviceAnalogAarm,
  openDevicePlan,
  openMaterialsDialog,
  syncGdSensorInfo,
  selfCleaning,
  selfCalibration,
  setSendDataInterval,
  customLibrary,
  set611AlarmThreshold,
  setTime,
  setMN606SensorAlarmThreshold,
  updateHt300DeviceInfo,
  ht300ReadMatterHandle
} from './util';
import { isBoolean, isEmpty, isFunction, isNullOrUnDef, isObject } from '@/utils/is';
import { i18n } from '@/locale';

function isFault() {
  if (!this.singleDeviceDetail.mods || !this.singleDeviceDetail.mods.tvocMod) {
    return false;
  }

  return (
    this.singleDeviceDetail.mods.tvocMod.runstate !== ctt.RUNSTATE_FAULT &&
    this.singleDeviceDetail.mods.tvocMod.state !== ctt.POINT_STATE_DANGER &&
    this.singleDeviceDetail.mods.tvocMod.state !== ctt.POINT_STATE_WARN
  );
}

export default {
  data() {
    return {
      paramVisible: false,
      bgStateVisible: false,
      modelVisible: false,
      hiddenParams: {
        preventFlag: true,
        sceneLevel: true
      },
      commonMenu: [
        // { title: '维护记录', sort: 1, clickFunc: setDeviceCoordinate },
        {
          title: '设备位置',
          sort: 8,
          clickFunc: setDeviceCoordinate,
          excludes: [
            ctt.CB1223,
            ctt.CB12231,
            ctt.NRHM01,
            ctt.PMS6003,
            ctt.RFQF01,
            ctt.CR1224,
            ctt.HT100,
            ctt.HT200,
            ctt.HT300,
            ctt.CT1226,
            ctt.CRA1221,
            ctt.PTQXZ,
            ctt.FCBR_100_v2,
            ctt.EFM100,
            ctt.FCBR100_N
          ]
        },
        {
          title: '预案',
          sort: 9,
          clickFunc: openDevicePlan,
          excludes: [
            ctt.CB1223,
            ctt.CB12231,
            ctt.NRHM01,
            ctt.PMS6003,
            ctt.RFQF01,
            ctt.CR1224,
            ctt.HT100,
            ctt.HT200,
            ctt.HT300,
            ctt.CT1226,
            ctt.CRA1221,
            ctt.MN_606,
            ctt.PTQXZ,
            ctt.FCBR_100_v2,
            ctt.EFM100,
            ctt.FCBR100_N,
            ctt.RM1000
          ]
        }
      ],
      menuMap: {
        fcbr100pro: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01040410' },
          { title: '参数调整', clickFunc: modifyParam, code: '01040401' },
          {
            title: '分析模型',
            disabled: isFault, // 非报警情况下禁用
            clickFunc: analysisModel,
            code: '01040406'
          },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040408' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040409' }
        ],
        fcbr100cfr: [
          {
            title: '设备控制',
            code: '01040412',
            suffixIcon: 'el-icon-caret-bottom',
            sort: 0,
            children: [
              { title: '自清洁', clickFunc: selfCleaning, code: '0104041201' },
              { title: '自校准', clickFunc: selfCalibration, code: '0104041202' },
              { title: '数据间隔', clickFunc: setSendDataInterval, code: '0104041203' }
            ]
          },
          { title: '自定义库', sort: 1, clickFunc: customLibrary, code: '01040411' },
          { title: '报警演练', sort: 3, clickFunc: setDeviceAnalogAarm, code: '01040410' },
          { title: '参数调整', sort: 2, clickFunc: modifyParam, code: '01040401' },
          { title: '历史报警', sort: 4, clickFunc: toHisWarn, code: '01040408' },
          { title: '本底状态', sort: 5, clickFunc: bgroundState, code: '01040409' }
        ],
        fcbr100: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01040209' },
          { title: '参数调整', clickFunc: modifyParam, code: '01040201' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040207' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040208' }
        ],
        fcbr100proga: [
          { title: '参数调整', clickFunc: modifyParam, code: '01040401' },
          {
            title: '分析模型',
            disabled: isFault, // 非报警情况下禁用
            clickFunc: analysisModel,
            code: '01040406'
          },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040408' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040409' }
        ],
        fcbr100ga: [
          { title: '参数调整', clickFunc: modifyParam, code: '01040201' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040207' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040208' }
        ],
        fcbr100b: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01040309' },
          { title: '参数调整', clickFunc: modifyParam, code: '01040301' },
          { title: '专家模式', clickFunc: toExpert, code: '01040304' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040307' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040308' }
        ],
        fcbr100f: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01040509' },
          { title: '参数调整', clickFunc: modifyParam, code: '01040501' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040508' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040509' }
        ],
        fcbr100cp: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01041804' },
          { title: '参数调整', clickFunc: modifyParam, code: '01041801' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041802' },
          { title: '本底状态', clickFunc: bgroundState, code: '01041803' },
          {
            title: '分析模型',
            disabled: isFault, // 非报警情况下禁用
            clickFunc: analysisModel,
            code: '01041804'
          }
        ],
        fcbr100c: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01041904' },
          { title: '参数调整', clickFunc: modifyParam, code: '01041901' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041902' },
          { title: '本底状态', clickFunc: bgroundState, code: '01041903' }
        ],
        fcbr100s1: [
          { title: '报警演练', clickFunc: setDeviceAnalogAarm, code: '01042004' },
          { title: '历史数据', clickFunc: toHisData2, code: '01042004' },
          { title: '参数调整', clickFunc: modifyParam, code: '01042001' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01042002' },
          { title: '本底状态', clickFunc: bgroundState, code: '01042003' }
        ],
        fcbr100m: [
          { title: '参数调整', clickFunc: modifyParam, code: '01042301' },
          { title: '故障记录', clickFunc: toFaultRecord, code: '01042303' },
          { title: '报警记录', clickFunc: toHisWarn, code: '01042302' },
          { title: '系统状态', clickFunc: musicboxSysStatus, code: '01042304' },
          { title: '设置', clickFunc: musicboxSetting, code: '01042305' }
        ],
        fcbr100n: [{ title: '参数调整', clickFunc: modifyParam, code: '01040201' }],
        BM4000: [
          { title: '历史数据', clickFunc: toHisData, code: '01040601' },
          { title: '参数调整', clickFunc: modifyParam, code: '01040602' },
          { title: '多台监控', clickFunc: mulMonitor, code: '01040603' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040604' },
          { title: '本底状态', clickFunc: bgroundState, code: '01040605' }
        ],
        chemPro100: [
          { title: '历史数据', clickFunc: toHisData2, code: '01042004' },
          { title: '参数调整', clickFunc: modifyParam, code: '01040801' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040802' }
        ],
        chemProFXi: [
          { title: '参数调整', clickFunc: modifyParam, code: '01040901' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01040902' }
        ],
        rg500: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041001' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041002' }
        ],
        ngp2: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041101' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041102' }
        ],
        geminiN: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041201' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041202' }
        ],
        vp100: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041401' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041402' }
        ],
        vp200: [
          { title: '参数调整', clickFunc: modifyParam, code: '01042201' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01042202' }
        ],
        pidIndApp: [{ title: '参数调整', clickFunc: modifyParam, code: '01042501' }],
        fitRM: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041701' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041702' }
        ],
        rs500: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041301' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041302' }
        ],
        Rmse: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041501' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041402' }
        ],
        Rmsc: [
          { title: '参数调整', clickFunc: modifyParam, code: '01041601' },
          { title: '历史报警', clickFunc: toHisWarn, code: '01041602' }
        ],
        CR: [{ title: '检测记录', clickFunc: testingRecord, code: '01042101' }],
        bc500: [
          { title: '采样记录', clickFunc: toSampleRecord, code: '01042403' },
          { title: '系统状态', clickFunc: makeBC500SysStatus, code: '01042401' },
          {
            title: '设置',
            disabled: () => {
              return !this.usableSetting;
            },
            clickFunc: makeBC500Setting,
            code: '01042402'
          }
        ],
        ac200: [{ title: '参数调整', clickFunc: modifyParam, code: '01041501' }],
        rg05: [
          // {
          //   title: '设置',
          //   clickFunc: popRG05Setting,
          //   code: '01042402'
          // }
        ],
        gd606: [
          {
            title: '气体数据库',
            clickFunc: openMaterialsDialog,
            code: '01042701'
          },
          {
            title: '同步传感器配置',
            clickFunc: syncGdSensorInfo
          }
        ],
        cd603: [
          {
            title: '同步传感器配置',
            clickFunc: syncGdSensorInfo
          }
        ],
        cd602: [],
        gd612: [
          {
            title: '同步传感器配置',
            clickFunc: syncGdSensorInfo
          },
          {
            title: '报警阈值设置',
            clickFunc: set611AlarmThreshold,
            code: '01042702'
          }
        ],
        gm606: [
          {
            title: '同步传感器配置',
            clickFunc: syncGdSensorInfo
          },
          {
            title: '报警阈值设置',
            clickFunc: set611AlarmThreshold,
            code: '01042702'
          }
        ],
        gm602: [
          {
            title: '同步传感器配置',
            clickFunc: syncGdSensorInfo
          },
          {
            title: '报警阈值设置',
            clickFunc: set611AlarmThreshold,
            code: '01042702'
          }
        ],
        CB12231: [
          {
            title: '时间同步',
            clickFunc: setTime
          }
        ],
        mn606: [
          {
            title: '报警阈值设置',
            clickFunc: setMN606SensorAlarmThreshold,
            code: '01042702'
          }
        ],
        ht300: [
          {
            title: '读取设备物质库',
            clickFunc: ht300ReadMatterHandle,
            code: '01042901'
          },
          {
            title: '设备信息设置',
            clickFunc: updateHt300DeviceInfo
            // code: '01042402'
          }
        ],
        CR0534: [{ title: '参数调整', clickFunc: modifyParam, code: '01042801' }],
        rm1000: [{ title: '参数调整', clickFunc: modifyParam, code: '01042801' }]
      }
    };
  },
  filters: {
    weatherText(mods) {
      if (mods && mods.weatherMod) {
        const { windSpeedValue, windDirectionValue, windScale } = mods.weatherMod;

        let template = `${i18n.t('风')}: (
        ${i18n.t('速')}: ${windSpeedValue}m/s;
        ${i18n.t('向')}: ${windDirectionValue};
        ${i18n.t('力')}: ${windScale} ${i18n.t('级')}
        )`;

        return template;
      }
    },
    o2Text(mods) {
      if (mods && mods.ecMod) {
        const { value } = mods.ecMod.o2 || {};
        return `${i18n.t('氧气')}: ${value || '0'}vol%`;
      }
    },
    humidity(mods) {
      if (!mods || !mods.cwaMod) return '';
      return `${i18n.t('湿度')}: ${mods.cwaMod.humidity || 0}%RH`;
    },
    temperature(mods) {
      if (!mods || !mods.cwaMod) return '';
      return `${i18n.t('温度')}: ${mods.cwaMod.temp || 0}℃`;
    },
    pm25Text(mods) {
      if (
        isEmpty(mods?.smokeMod) ||
        !isObject(mods?.smokeMod) ||
        !isObject(mods?.smokeMod?.pmDto)
      ) {
        return '';
      }

      const { pm25 } = mods.smokeMod.pmDto;

      return !isEmpty(pm25) ? `pm2.5: ${pm25} μg/m³` : '';
    },
    pm10Text(mods) {
      if (isEmpty(mods?.smokeMod) || !isObject(mods?.smokeMod)) return '';

      const { pm10 } = mods.smokeMod;

      return pm10 ? pm10 + 'μg/m³' : '';
    }
  },
  computed: {
    ...mapState('history', ['historyDetailData']),
    ...mapState('bc500', ['usableSetting']),
    ...mapState('socket', ['singleDeviceDetail', 'subDeviceMap']),
    ...mapGetters('socket', ['currentChooseDevice']),
    sn() {
      return this.$route.params.sn;
    },
    deviceType() {
      return this.$route.params.deviceType;
    },
    weatherData() {
      return this.isHisDetail ? this.historyDetailData : this.singleDeviceDetail;
    },
    currentDeviceDetail() {
      return this.subDeviceMap[this.sn] || this.singleDeviceDetail || {};
    },
    runstateOption() {
      const { runstate, state } = this.isHisDetail
        ? this.historyDetailData
        : this.currentDeviceDetail;
      return getStateOption({ state, runstate });
    }
  },
  methods: {
    selectHandler(index) {
      if (isNullOrUnDef(index)) return;
      this.headerTabs[index].clickFunc?.(this);
    },
    dropdownSelectHandler(e) {
      if (isNullOrUnDef(e) || this.isDisabled(e.disabled)) {
        console.log('按钮被禁用', e.title);
        return;
      }
      e.clickFunc(this);
    },
    isDisabled(dis) {
      if (isFunction(dis)) return dis.call(this);
      if (isBoolean(dis)) return dis;
      return false;
    },
    closeLoading() {
      this.mapLoading && this.mapLoading.close();
    },
    modelHandler() {
      this.modelVisible = false;
    }
  }
};
